import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";


export const getStpList = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.STP.GET_STP_LIST,
        { params: params }
    );
    return response?.data;
    

};

//Update STP
export const updateSTP = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.STP.UPDATE_STP}/${id}`, body);
};


export const getSTPWeekBySTP = async (id: number | any, params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.STP.GET_STP_WEEKS_BY_STP}/${id}`,
        { params: params }
    );
    console.log(
        "🚀 ~ file: STPRepository.ts ~ line 9 ~ getSTPWeekBySTP ~ response",
        response
    );
    return response?.data;
};

export const getBeatsData = async (params: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.Beat.GET_BEATS}`,
    { params: params }
  )
   return response?.data;
}
//Update STP
export const updateSTPWeek = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.STP.UPDATE_STP_WEEK}/${id}`, body);
};

export const getTerritoryByEmpId = async (params: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.STP.GET_TERRITORY_BY_EMP_ID}`,
    { params: params }
  )
   return response?.data;
}